import { render } from "./FullPageAlert.vue?vue&type=template&id=6a03172a&scoped=true"
import script from "./FullPageAlert.vue?vue&type=script&lang=js"
export * from "./FullPageAlert.vue?vue&type=script&lang=js"

import "./FullPageAlert.vue?vue&type=style&index=0&id=6a03172a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a03172a"]])

export default __exports__